import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2.3rem;
  font-weight: bold;
  font-family: var(--poppins);
  margin-top: 80px;
  color: var(--white);
  text-align: center;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: 2rem;
  }
`;

export const TitleService = styled.h1`
  font-size: 2.3rem;
  font-weight: bold;
  font-family: var(--poppins);
  margin-top: 5px;
  color: var(--white);
  text-align: center;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: 2rem;
  }
`;

export const SubtitleNewCard = styled.button`
  background: none;
  height: 160px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 1.4rem;
  font-family: var(--poppins);
  margin: 5px;
  color: var(--white);
  text-align: center;
  line-height: 1.6;
  span {
    font-size: 1.4rem;
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    font-size: 0.9rem;
    text-align: center;
    justify-items: center;
    margin: 0;
    height: auto;
    width: fit-content;
  }
`;

export const Text = styled.h4`
  font-size: 1rem;
  font-family: var(--poppins);
  margin-top: 80px;
  color: var(--white);
  text-align: center;
  font-weight: normal;
  border: 1px solid blue;
  span {
    color: var(--secondary);
  }
`;

export const TextCircle = styled.h4`
  font-size: 1rem;
  font-family: var(--poppins);
  margin-top: 10px;
  color: var(--white);
  text-align: center;
  font-weight: normal;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: 0.7rem;
    text-align: left;
    margin: 0;
    max-width: 85%;
    line-height: 1.2;
  }
  @media screen and (max-width: 400px) {
    font-size: 0.6rem;
  }
`;

export const CardAnchor = styled.div`
  font-size: 1.2rem;
  font-family: var(--poppins);
  color: var(--white);
  position: absolute;
  bottom: 25px;
  font-weight: bold;
  width: calc(100% - 20px);
  text-align: center;
  span {
    color: var(--secondary);
  }
`;
